import React from "react";
import {DynamicIcon} from "lucide-react/dynamic";
import {HDate} from "@hebcal/core";
import Hebcal from "../../hebcal";
import {MOBCOLORS} from "../../configs/AppConfig";


export const contactHeaderIconStore=[
    {
        key:"GENRE_HOMME",
        icon:"mars",
        color:MOBCOLORS.cyan.color,
        description:null
    },
    {
        key:"GENRE_FEMME",
        icon:"venus",
        color:MOBCOLORS.pink.color,
        description:null
    },
    {
        key:"ARCHIVE",
        icon:"archive",
        color:'#000',
        description:null
    },
    {
        key:"CHEF",
        icon:"crown",
        color:MOBCOLORS.amber.color,
        description:null
    },
    {
        key:"DECEDE",
        icon:"cloud",
        color:'#000',
        description:null
    },
    {
        key:"DELETED",
        icon:"trash-2",
        color:MOBCOLORS.red.color,
        description:null
    },
    {
        key:"BABY",
        icon:"baby",
        color:MOBCOLORS.indigo.color,
        description:null
    },
    {
        key:"MARIED",
        icon:"heart-handshake",
        color:MOBCOLORS.purple.color,
        description:null
    },
    {
        key:"FAMILY",
        icon:"person-standing",
        color:MOBCOLORS.orange.color,
        description:null
    },
    {
        key:"AGE",
        icon:"cake",
        color:MOBCOLORS.teal.color,
        description:null
    },
]

export default function MobContactHeader({contact,size,reversed}) {
    //console.log("ICON FOR",contact)

    const getAgeHeb = (ddn, todayDate = new Date()) => {
        const todayHDate = new HDate(todayDate);
        const birthHDate = getHebddn(ddn, true); // renvoie une HDate
        let age = todayHDate.getFullYear() - birthHDate.getFullYear();

        // Crée l'anniversaire hébraïque de cette année (en HDate)
        const birthdayThisYear = new HDate(birthHDate.getDate(), birthHDate.getMonth(), todayHDate.getFullYear());

        // Compare les équivalents grégoriens
        if (todayDate.getTime() < birthdayThisYear.greg().getTime()) {
            age--;
        }

        return age;
    };

    const getHebddn=(ddn,getHDate=false)=>{
        let org = null
        try {
            org = JSON.parse(localStorage.getItem("ORG"))
        } catch (e) {
        }

        var hdate = new HDate(new Date(ddn))
        if (org) {
            const hebcal = new Hebcal(org, new Date(), org.lat, org.long)
            hdate = hebcal.getAnnivHDate(new Date(ddn))
        }
        if(getHDate){
            return hdate
        }
        return hdate.getDate() + " " + hdate.getMonthName() + " " + hdate.getFullYear()
    }


    size=size || 20

    if (!contact) {
        return null
    }

    let finalIcons=[]

    const addIcon=(iconKey,value=0)=>{
        let _icon=contactHeaderIconStore.find((item)=>item.key===iconKey);
        if(_icon){
            if(value){
                _icon.value=value
            }
            finalIcons.push(_icon)
        }
    }

    if(contact.deleted){
        addIcon("DELETED")
    }

    if(contact.archived){
        addIcon("ARCHIVE")
    }

    if(contact.deceased){
        addIcon("DECEDE")
    }

    if (contact.homme === true) {
        addIcon("GENRE_HOMME")
    }

    if (contact.homme === false) {
        addIcon("GENRE_FEMME")
    }

    if (Array.isArray(contact.parents) && contact.parents.length > 0) {
        addIcon("BABY")
    }

    if(contact.familyLinks?.length>0)
    {
        const femmes=contact.familyLinks.filter(i=>i.type==="MARI")
        if(femmes.length>0){
            addIcon("MARIED")
        }

        const enfants=contact.familyLinks.filter(i=>i.type==="PERE")
        if(enfants.length>0){
            addIcon("FAMILY",enfants.length)
        }
    }

    if(contact.ddn)
    {
        const age=getAgeHeb(contact.ddn)
        addIcon("AGE",age)
    }

    if (contact.chef) {
        addIcon("CHEF")
    }

    return(
        <span className={"mr-1"} style={{color:"#000",display:"flex",flexDirection:reversed?"row-reverse":"row",alignItems:"flex-start",gap:2}}>
            {finalIcons.map(item=>{
                return(
                    <div key={item.key} style={{display:"flex",flexDirection:"column",alignItems:"center",gap:3}}>
                        <DynamicIcon
                            name={item.icon}
                            color={item.color || '#000'}
                            size={size}
                            style={{display:"flex",alignItems:"center",justifyContent:"center"}}
                        />

                        {item.value !== undefined &&(
                            <span style={{color:item.color,fontSize:10,textAlign:"center"}}>{item.value}</span>
                        )}
                    </div>
                )
            })}
        </span>
    )
}
